import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, Table, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import IconPlus from '../../assets/images/icon-plus.png';
import IconFile from '../../assets/images/file-up.png';
import ExcelIcon from '../../assets/images/excelIcon.png';
import IconDow from '../../assets/images/dowload.png';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import profilePic from '../../assets/images/users/no-img.jpg';
import IconD from '../../assets/images/IconDow.png';
import IconUp from '../../assets/images/IconUp.png';
import IconCheckbox from '../../assets/images/icon-checkbox.png';
import IconCheckboxActive from '../../assets/images/icon-checkbox-active.png';
import { cloneDeep } from 'lodash';
import { Product_status_warehouse } from '../../constants/nutriconstant';
import IconCheckboxPart from "../../assets/images/icon-checkbox-part.png";
import IconT from "../../assets/images/iconT.png"

const configPage = {
    titlePage: 'Danh sách sản phẩm',
    pathPage: '/product',
    column: 10,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}

export const ProductType: any = [

    {
        value: 'medicine',
        label: "Thuốc",
    },
    {
        value: 'functional_foods',
        label: "Thực phẩm chức năng",
    },
    {
        value: 'materials',
        label: "Vật tư",
    },
]
export const Stock: any = [

    {
        value: 'out_of_stock',
        label: "Hết hàng",
    },
    {
        value: 'almost_out_of_stock',
        label: "Sắp hết hàng",
    },
    {
        value: 'stocking',
        label: "Còn hàng",
    },
]
export const ProductStatus: any = [

    {
        value: 1,
        label: "Hoạt động",
    },
    {
        value: 0,
        label: "Ẩn",
    },
]



const List: React.FC<Props> = (props: Props) => {

    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const [category, setCategory] = useState<any>([]);
    const searchPrams = queryString.parse(props.location.search)
    const [branch, setBranch] = useState([])
    const [age, setAge] = useState<any>();
    const [pathologicals, setPathologicals] = useState<any>();

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        getFilterParams()
        loadInit();
        fetchAge();
        fetPathologicals();
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page: page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        }
        const [
            responseCategory,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/category`, params),
        ]);
        if (responseCategory.response?.data !== undefined) {
            let ListArr: any = [{
                value: "",
                label: "-Danh mục-",
            }];
            responseCategory.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setCategory(ListArr)
        }
    }

    const loadData = async () => {
        const formData = {
            page: page,
            limit: limit,
            role: 'user',
            sort: "asc | desc",
            order_by: "name",
            include_product_stock: true,
            include_product_transfer: true,
            include_product_hold: true,
            include_price_cost: true,
            ...filter,
        }
        if (formData?.name === "") {
            delete formData?.name
        }
        if (formData?.product_type === "") {
            delete formData?.product_type
        }
        if (formData?.stock_status === "") {
            delete formData?.stock_status
        }
        if (formData?.category_id === "") {
            delete formData?.category_id
        }
        if (formData?.role_id === "") {
            delete formData?.role_id
        }
        const url = `${baseUrl}/product`;
        setLoading(true);
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }

    useEffect(() => {
        responseBranch()
    }, [data]);

    const responseBranch = async () => {
        const params: any = {
            page: 1,
            limit: 200,
        }
        const url = `${baseUrl}/branch`;
        let response: any = await APIClient.GET(url, params);
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response?.response?.data !== undefined) {
            const arr = Array.isArray(response?.response?.data) && response.response.data.length > 0
                ? response.response.data
                    .filter((data: any) => data?.status !== 0)
                    .map((data: any) => ({
                        ...data,
                        value: data?.id,
                        label: data?.name
                    }))
                : [];
            setBranch(arr.length > 0 ? arr : []);
        }
    }
    // api độ tuổi , bệnh lý
    const fetchAge = async () => {
        const url = `${baseUrl}/product/ages`;
        // setLoading(true);
        let response: any = await APIClient.GET(url);
        // setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error);
        } else if (response.response?.data !== undefined) {
            let Arr: any = [{
                value: '',
                label: '-Độ tuổi-'
            }];
            response.response?.data?.map((item: any) => {
                Arr.push({
                    value: item?.id,
                    label: item?.name,
                    ...item
                })
            })
            setAge(Arr);
        }
    }
    const fetPathologicals = async () => {
        const url = `${baseUrl}/product/pathologicals`;
        // setLoading(true);
        let response: any = await APIClient.GET(url);
        // setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error);
        } else if (response.response?.data !== undefined) {
            let Arr: any = [{
                value: '',
                label: '-Bệnh lý-'
            }];
            response.response?.data?.map((item: any) => {
                Arr.push({
                    value: item?.id,
                    label: item?.name,
                    ...item
                })
            })
            setPathologicals(Arr);
        }
    }
    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    branch={branch}
                    filter={filter}
                    category={category}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                    handleActionModal={(data: any) => handleActionModal(data)}
                    age={age}
                    pathologicals={pathologicals}
                />
                <DataTableList
                    branch={branch}
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                    type={"noresetpage"}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} />
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, configPage, handleActionModal, branch } = props
    const start = limit * (page - 1)
    let color: any = ""
    const RenderHeadData = () => {
        return (
            <thead  >
                <tr style={{ backgroundColor: "#ECECEC" }}>
                    <th className=" sticky-position" style={{ minWidth: 60, backgroundColor: "#ECECEC" }}>Mã sản phẩm</th>
                    <th className=" sticky-position" style={{ minWidth: 60, backgroundColor: "#ECECEC" }}>Ảnh</th>
                    <th className=" sticky-position" style={{ minWidth: 350, backgroundColor: "#ECECEC" }}>Tên sản phẩm</th>
                    <th className=" sticky-position" style={{ minWidth: 120, backgroundColor: "#ECECEC" }}>Mã vạch</th>
                    <th className=" sticky-position" style={{ minWidth: 250, backgroundColor: "#ECECEC" }}>Tồn kho </th>
                    <th className=" sticky-position" style={{ minWidth: 120, backgroundColor: "#ECECEC" }}>Tồn đang chuyển </th>
                    <th className=" sticky-position" style={{ minWidth: 160, backgroundColor: "#ECECEC" }}>Tạm giữ</th>
                    <th className=" sticky-position" style={{ minWidth: 120, backgroundColor: "#ECECEC" }}>Có thể bán</th>
                    <th className=" sticky-position" style={{ minWidth: 120, backgroundColor: "#ECECEC" }}>Hết hạn</th>
                    <th className=" sticky-position" style={{ minWidth: 120, backgroundColor: "#ECECEC" }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {

        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có sản phẩm nào!" />;
        }

        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => {
                    let stock_quantity: any = {}
                    if (item?.product_variants?.length > 0) {
                        stock_quantity = item?.product_variants?.reduce((prevStock: any, itemStock: any) => {
                            const stockVarriant = itemStock?.product_stock?.reduce((prevStockSub: any, itemStockSub: any) => {
                                prevStockSub.quantity = prevStockSub.quantity + Number(itemStockSub?.quantity || 0)
                                return prevStockSub
                            }, { quantity: 0 })
                            prevStock.quantity = prevStock.quantity + Number(stockVarriant?.quantity || 0)
                            return prevStock
                        }, { quantity: 0 })
                    } else {
                        stock_quantity = item?.product_stock?.reduce((prevStock: any, itemStock: any) => {
                            prevStock.quantity = prevStock.quantity + Number(itemStock?.quantity || 0)
                            return prevStock
                        }, { quantity: 0 })
                    }
                    const stock_quantity_transfer = item?.product_stock_transfer?.reduce((prevTransfer: any, itemTransfer: any) => {
                        prevTransfer += Number(itemTransfer?.quantity || 0)
                        return prevTransfer
                    }, 0)
                    const stock_quantity_hold = item?.product_stock_hold?.reduce((prevHold: any, itemHold: any) => {
                        prevHold += Number(itemHold?.quantity || 0)
                        return prevHold
                    }, 0)

                    const stock_quantity_is_sale = Number(stock_quantity?.quantity || 0) - Number(stock_quantity_transfer || 0) - Number(stock_quantity_hold || 0)
                    return (
                        <Item branch={branch} handleActionModal={handleActionModal} item={item} stock_quantity={stock_quantity} key={`${item?.id}-${index}`} stock_quantity_transfer={stock_quantity_transfer} stock_quantity_hold={stock_quantity_hold} stock_quantity_is_sale={stock_quantity_is_sale} />
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};
const Item = (props: any) => {
    const { item, stock_quantity, stock_quantity_transfer, stock_quantity_hold, stock_quantity_is_sale, branch } = props
    const [icon, setIcon] = useState<any>(false)
    const router = useHistory()
    const gotoDetail = (item: any) => {
        router?.push(`/product/${item?.id}/view`)
    }

    return (
        <>
            <tr >
                <td style={{ minWidth: 120 }} onClick={() => gotoDetail(item)}>{item?.code} </td>
                <td onClick={() => gotoDetail(item)}>
                    <label className="tee-file-preview" htmlFor="avatar" style={{ width: 40, height: 40, marginRight: 10 }}>
                        <img src={item.product_images && item.product_images[0]?.url || profilePic} style={{ maxWidth: 'unset', maxHeight: 'unset' }} />
                    </label>
                </td>
                <td > <span style={{ fontWeight: "bold" }}>
                    <div className='stock'>
                        <div onClick={() => gotoDetail(item)}>
                            {item?.name}
                        </div>
                        <div>
                            {stock_quantity?.quantity !== 0 ? <img alt="" style={{ border: "none" }} src={icon == false ? IconUp : IconD} onClick={() => { setIcon(!icon) }} width={14} height={10} /> : ""}
                        </div>
                    </div>
                </span> &ensp; <br />
                    {stock_quantity?.quantity === 0 || stock_quantity?.quantity == undefined
                        ? <span style={{ color: '#FD4858' }}>Sản phẩm đã hết hàng
                        </span>
                        : stock_quantity?.quantity > 0 && stock_quantity?.quantity <= 5
                            ? (
                                <span style={{ color: '#7F31FF' }}>Sản phẩm sắp hết hàng</span>
                            )
                            : " "}
                </td>
                <td onClick={() => gotoDetail(item)}>{item?.barcode}</td>
                <td onClick={() => gotoDetail(item)} style={{
                }}>
                    {PriceUtils.format(stock_quantity?.quantity, '') || "---"}
                </td>
                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(stock_quantity_transfer, '') || "---"}</td>
                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(stock_quantity_hold, '') || "---"}</td>
                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(stock_quantity_is_sale, '') || "---"}</td>
                <td onClick={() => gotoDetail(item)}>{"---"}</td>
                <td>
                    <div className="table-action">
                        <div className="button-nutri" onClick={() => router?.push(`/product/${item?.id}`)}>
                            <img style={{ border: 'none' }} src={IconEdit} width={20} height={20} alt="" />
                        </div>
                        <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'delete', data: item })}><i className='uil-trash-alt'></i></div>
                    </div>
                </td>
            </tr>
            {icon &&
                <Item2 branch={branch} item={item} stock_quantity={stock_quantity} stock_quantity_transfer={stock_quantity_transfer} stock_quantity_hold={stock_quantity_hold} stock_quantity_is_sale={stock_quantity_is_sale} />
            }
        </>
    )
}
const Item2 = (props: any) => {
    const { item, stock_quantity, branch } = props

    const [icon, setIcon] = useState<any>(false)
    const router = useHistory()
    const gotoDetail = (item: any) => {
        router?.push(`/product/${item?.id}/view`)
    }

    const getColorBasedOnQuantity = (quantity: any) => {
        if (quantity > 0 && quantity < 5) {
            return { color: '#F19C1D', };
        } else if (quantity >= 5) {
            return { color: '#48A800', };
        } else {
            return { color: '#FF0000', };
        }
    };
    return (
        <>
            <tr >
                <td colSpan={"10"} style={{ pointerEvents: "none" }}>
                    <span >
                        <div className='stock' style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {branch?.map((e: any) => (
                                    <img className='custom-img' src={IconT} alt="" style={{ border: "none" }} />
                                ))}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '97%' }}>
                                {branch?.map((e: any) => (
                                    <div className='mt-3 rounded-sm w-full custom-container' key={e.id} >
                                        <li className='branch custom-li' >
                                            {e?.name}:
                                            {item?.product_stock && item.product_stock.some((arb: any) =>
                                                arb?.branch_id?.id === e?.id && arb?.quantity > 0) ? (
                                                item.product_stock.some((arb: any) =>
                                                    arb?.branch_id?.id === e?.id && arb?.quantity > 0 && arb?.quantity < 5) ? (
                                                    <span style={{ color: '#F19C1D'}}> Sản phẩm sắp hết hàng </span>
                                                ) : (
                                                    <span style={{ color: '#48A800' }}> Sản phẩm còn hàng</span>
                                                )
                                            ) : (
                                                <span style={{ color: '#FF0000'}}> Sản phẩm hết hàng</span>
                                            )}

                                        </li>
                                        <div className='ml-auto' style={{ marginRight: "57%" }}>
                                            {item?.product_stock !== 0 && (
                                                <span key={e.id}>
                                                    {item?.product_stock?.some((arb: any) => arb?.branch_id?.id === e?.id) ? (
                                                        item.product_stock.map((arb: any) => {
                                                            if (arb?.branch_id?.id === e?.id) {
                                                                const quantityColor = getColorBasedOnQuantity(arb?.quantity);
                                                                return (
                                                                    <span key={arb.id} style={quantityColor}>
                                                                        {!arb?.quantity ? 0 : arb?.quantity}
                                                                    </span>
                                                                );
                                                            }
                                                            return null;
                                                        })
                                                    ) : (
                                                        <span>0</span>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </span>
                </td>
            </tr>
        </>
    )
}

const DataFilter = (props: any) => {
    const { setFilter, filter, category, branch, age, pathologicals } = props
    const [name, setName] = useState(filter?.name);
    const [popupFilter, setPopupFilter] = useState(false);
    const [branchActive, setBranchActive] = useState<any>();
    const [ids, setIds] = useState<any>([]);
    const [statusWarehouse, setStatusWarehouse] = useState<any>([]);
    const timer = useRef<any>(null);
    useEffect(() => {
        filterActiveBranch()
    }, [branch])
    useEffect(() => {
        setFilter({
            ...filter,
            branch_ids: ids,
            stock_status_ids: statusWarehouse
        })
    }, [ids, statusWarehouse])
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        setFilter({
            ...filter,
            page: 1,
            [name]: value
        })
    }

    const toggleDropdown = () => {
        setPopupFilter(!popupFilter)
    }

    const filterActiveBranch = () => {
        let Arr: any = [];
        branch && branch?.map((item: any) => {
            if (item?.status == 1) {
                Arr.push(item)
            }
        })
        setBranchActive(Arr)
    }

    const checkAll = (e: any) => {
        if (e.target.checked) {
            setIds(
                branchActive?.reduce((prev: any, item: any) => {
                    prev = [...prev, item?.id];
                    return prev;
                }, [])
            );
        } else {
            setIds([]);
        }
    };

    const checkedIds = (id: any) => {
        const idsTMP = cloneDeep(ids);
        return idsTMP.find((item: any) => {
            return item === id;
        });
    };

    const toggleIds = (status: any, id: any) => {
        const idsTMP = cloneDeep(ids);
        if (status) {
            //check xem có ko
            if (!checkedIds(id)) {
                idsTMP.push(id);
                setIds(idsTMP);
            }
        } else {
            //remove
            var index = idsTMP.indexOf(id);
            if (index !== -1) {
                idsTMP.splice(index, 1);
                setIds(idsTMP);
            }
        }
    };

    const checkeduWarehouse = (value: any) => {
        const idsTMP = cloneDeep(statusWarehouse);
        return idsTMP.find((item: any) => {
            return item === value;
        });
    };

    const toggleWarehouse = (status: any, value: any) => {
        const idsTMP = cloneDeep(statusWarehouse);
        if (status) {
            //check xem có ko
            if (!checkeduWarehouse(value)) {
                idsTMP.push(value);
                setStatusWarehouse(idsTMP);
            }
        } else {
            //remove
            var index = idsTMP.indexOf(value);
            if (index !== -1) {
                idsTMP.splice(index, 1);
                setStatusWarehouse(idsTMP);
            }
        }
    };

    const FilterInventory = () => {
        return (
            <div className='filter_content_product' style={{ height: 'auto' }}>
                <div className='ad_filter_header'>
                    <div className='bit_title'>Bộ lọc theo từng kho</div>
                    <button onClick={() => toggleDropdown()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className='mt-2'>
                    <div className='mb-2'>Tồn kho</div>
                    <div style={{ maxHeight: 150, overflow: 'auto' }} className='border'>
                        <div className='d-flex pt-2 pb-2 ml-2'>
                            <div
                                className="icon mr-1"
                                onClick={() =>
                                    checkAll({
                                        target: {
                                            checked: !(ids?.length > 0 && ids?.length === branchActive?.length),
                                        },
                                    })}
                            >
                                {ids?.length > 0 && ids?.length === branchActive?.length ? (
                                    <img
                                        src={IconCheckboxActive}
                                        height={20}
                                        width={20}
                                        alt="icon"
                                    />
                                ) : ids?.length > 0 && ids?.length !== branchActive?.length ? (
                                    <img
                                        src={IconCheckboxPart}
                                        height={20}
                                        width={20}
                                        alt="icon"
                                    />
                                ) : (
                                    <img src={IconCheckbox} height={20} width={20} alt="icon" />
                                )}
                            </div>
                            <div>Tất cả</div>
                        </div>
                        {branchActive?.map((item: any) => {
                            const checked = checkedIds(item?.id);
                            return (
                                <div className='d-flex pt-2 pb-2 ml-2'>
                                    <div className="icon mr-1" onClick={() => {
                                        toggleIds(!checked, item?.id)
                                    }}>
                                        {checked ? (
                                            <img
                                                src={IconCheckboxActive}
                                                height={20}
                                                width={20}
                                                alt="icon"
                                            />
                                        ) : (
                                            <img
                                                src={IconCheckbox}
                                                height={20}
                                                width={20}
                                                alt="icon"
                                            />
                                        )}
                                    </div>
                                    <div>{item?.label}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='mt-2'>
                    <div className='mb-2'>Chọn trạng thái tồn</div>
                    <div style={{ height: 110 }} className='border'>
                        {Product_status_warehouse?.map((item: any) => {
                            const checkedWarehouse = checkeduWarehouse(item?.value);
                            return (
                                <div className='d-flex pt-2 pb-2 ml-2'>
                                    <div className="icon mr-1" onClick={() => {
                                        toggleWarehouse(!checkedWarehouse, item?.value)
                                    }}>
                                        {checkedWarehouse ? (
                                            <img
                                                src={IconCheckboxActive}
                                                height={20}
                                                width={20}
                                                alt="icon"
                                            />
                                        ) : (
                                            <img
                                                src={IconCheckbox}
                                                height={20}
                                                width={20}
                                                alt="icon"
                                            />
                                        )}
                                    </div>
                                    <div>{item?.label}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Row className="mb-3 filter-custom">
            <Col xl={9}>
                <Row>
                    <Col xl={4}>
                        <Row>
                            <Col xl={12}>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                        <img src={IconSearch} width={18} height={18} alt="" />
                                    </InputGroupAddon>
                                    <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên hoặc mã sản phẩm, mã vạch" />
                                </InputGroup>
                            </Col>
                            <Col xl={12}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Tồn theo tổng kho-"
                                    options={[{
                                        value: "",
                                        label: "-Tồn theo tổng kho-",
                                    }, ...Stock]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'stock_status', value: value.value } })
                                    }}
                                    value={Stock?.filter((option: any) => filter?.stock_status == option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={8}>
                        <Row>
                            <Col xl={4}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Loại sản phẩm-"
                                    options={[{
                                        value: '',
                                        label: "-Loại sản phẩm-",
                                    }, ...ProductType]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'product_type', value: value.value } })
                                    }}
                                    value={ProductType?.filter((option: any) => filter?.product_type == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={4}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Danh mục-"
                                    options={category}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'category_id', value: value.value } })
                                    }}
                                    value={category?.filter((option: any) => filter?.category_id == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={4}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Độ tuổi-"
                                    options={age}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'product_age_id', value: value.value } })
                                    }}
                                    value={age?.filter((option: any) => filter?.product_age_id == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={4}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Bệnh lý-"
                                    options={pathologicals}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'product_pathological_id', value: value.value } })
                                    }}
                                    value={pathologicals?.filter((option: any) => filter?.product_pathological_id == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={4} className='onlyview'>
                                <Input
                                    type='text'
                                    placeholder="Tồn theo từng kho"
                                    className='mb-2'
                                    onClick={() => toggleDropdown()}
                                />
                                {popupFilter == true && (
                                    <FilterInventory />
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={3}>
                <div>
                    <div className="text-right">
                        <Button onClick={() => props?.handleActionModal({ type: 'excel' })} color="success" className="ml-2" style={{ backgroundColor: "#127F45" }}>
                            <img className='mr-1' style={{ border: 'none', fontWeight: "bold", paddingBottom: "5px" }} src={ExcelIcon} width={20} height={25} alt="" />
                            ImportExcel
                        </Button>
                        <Link to={`${configPage.pathPage}/add`}>
                            <Button color="success" className="ml-2">
                                <img className='mr-1' style={{ border: 'none' }} src={IconPlus} width={20} height={20} alt="" />
                                Thêm
                            </Button>
                        </Link>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props

    const handleStop = async () => {
        setLoading(true)
        const url = `${baseUrl}/product/${action?.data?.id}`;
        const params = {
            status: 0,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Ngừng hoạt động sản phẩm thành công')
            closeModal();
            loadData()
        }
    }

    const handleActive = async () => {
        setLoading(true)
        const url = `${baseUrl}/product/${action?.data?.id}`;
        const params = {
            status: 1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Kích hoạt sản phẩm thành công')
            closeModal();
            loadData()
        }
    }

    const handleDelete = async () => {
        setLoading(true)
        const url = `${baseUrl}/product/status/${action?.data?.id}`;
        const params = {
            status: -1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa sản phẩm thành công')
            closeModal();
            loadData()
        }
    }
    const [excelFile, setExcelFile] = useState<any>(null);

    const onDrop = (acceptedFiles: any) => {
        // Kiểm tra xem có tệp được tải lên hay không
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            // Kiểm tra định dạng tệp
            if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file?.type === "application/vnd.oasis.opendocument.spreadsheet") {
                setExcelFile(file);
            } else {
                // Hiển thị thông báo nếu tệp không đúng định dạng
                toast.success("Chỉ chấp nhận tệp định dạng Excel (.xls, .xlsx)");
            }
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: ".xls, .xlsx", // Định dạng tệp Excel
    });


    const importExcel = async () => {
        //check xem đúng file excel Ko
        if (excelFile?.file === '') {
            toast.error('Vui lòng chọn file excel để import');
            return;
        }
        const type = excelFile?.type
        let validTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
            "application/vnd.oasis.opendocument.spreadsheet"
        ]
        let checkTypeExcel = (validTypes.indexOf(type) > -1)
        if (checkTypeExcel === false) {
            toast.error('Định dạng file không hợp lệ, vui lòng chọn file excel');
            return;
        }
        const formData = new FormData();
        formData.append('file', excelFile)
        const url = `${baseUrl}/product/import`;
        setLoading(true)
        let response: any = await APIClient.POST(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            toast.success('Tải lên tệp thành công!');
            closeModal()
        }
    }

    if (!checkRole(props?.user?.roles, ['productEdit'], props?.user?.role)) {
        return (
            <CardBody className='p-0' style={{ width: 460 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>

        )
    }

    return (
        <CardBody className='p-0' style={{ width: action?.type === 'excel' ? 500 : 400 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {
                        action?.type === 'stop' ? "Vô hiệu hóa"
                            : action?.type === 'active' ? "Kích hoạt sản phẩm"
                                : action?.type === 'delete' ? "Xóa sản phẩm"
                                    : action?.type === 'excel' ? "Nhập danh sách"
                                        : "Thông báo"
                    }
                </h5>
                <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'stop' &&
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn có chắc chắn muốn vô hiệu hóa sản phẩm <br /><b>{action?.data?.phone}</b>
                            </p>
                        }
                        {action?.type === 'active' &&
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn có chắc chắn muốn kích hoạt sản phẩm này không?
                            </p>
                        }
                        {action?.type === 'delete' &&
                            <p className="font-size-14" style={{ textAlign: 'center' }}>
                                Bạn có chắc chắn muốn xóa sản phẩm này không?
                            </p>
                        }
                        {action?.type === 'excel' &&
                            <div>
                                <div style={{ backgroundColor: "#EEF6FF", height: '60px', width: "470px", border: "1px dashed #3183FF", borderRadius: "5px", display: 'flex', alignItems: 'center' }}>
                                    <img className='mr-1' style={{ border: 'none', marginLeft: "10px" }} src={IconFile} width={30} height={30} alt="" />
                                    <div {...getRootProps()} className="product-file-upload" style={{ display: 'flex', alignItems: 'center', margin: "18px 0px 0px 15px" }}>
                                        <input {...getInputProps()} />
                                        {excelFile ? (
                                            <p style={{ paddingTop: "10px" }} className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                                <span style={{ fontWeight: "bold" }}>Tệp của bạn</span> : {excelFile.name}
                                            </p>
                                        ) : (
                                            <p ><span style={{ fontWeight: "bold" }}>Trình tải lên tệp nhanh</span> <br /><span style={{ opacity: "0.5" }}>Kéo & Thả hoặc chọn tệp từ máy tính</span></p>
                                        )}
                                    </div>
                                </div>
                                <br />
                                <a href="/Danh_sach_san_pham_Nutri.xlsx" download>
                                    <img className='mr-1' style={{ border: 'none', marginLeft: "130px" }} src={IconDow} width={200} height={30} alt="" />
                                </a>
                                <br />
                            </div>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                {/* <Button
                    onClick={closeModal} 
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button> */}
                <Button
                    onClick={() => {
                        action?.type === 'stop' && handleStop()
                        action?.type === 'active' && handleActive()
                        action?.type === 'delete' && handleDelete()
                        action?.type === 'excel' && importExcel()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)